import { Space, Tag as AntdTag, Tooltip, Typography } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";
import {
  getCustomerSatisfactionSummaryColor,
  getCustomerSatisfactionSummaryLabel,
} from "../../../models/customer-satisfaction/enum";
import { ICustomerSatisfactionStatusSummary } from "../../../models/order/response";

interface IProps {
  status?: ICustomerSatisfactionStatusSummary | null;
  fallbackStatus?: number | null;
}

const CustomerSatisfactionStatusTag: React.FC<IProps> = ({
  status,
  fallbackStatus,
}) => {
  const { t } = useTranslation();
  const label = getCustomerSatisfactionSummaryLabel(status, fallbackStatus);
  const title = status?.label || t(label);
  const tag = (
    <AntdTag
      color={getCustomerSatisfactionSummaryColor(status, fallbackStatus)}
    >
      {title}
    </AntdTag>
  );
  const tooltipItems = [
    status?.determinedAt
      ? {
          label: t("determined_at"),
          value: moment(status.determinedAt).format("YYYY-MM-DD HH:mm:ss"),
        }
      : null,
    status?.reason?.reason
      ? { label: t("reason"), value: status.reason.reason }
      : null,
    status?.handlingMethod
      ? { label: t("handling_method"), value: status.handlingMethod }
      : null,
    status?.customerReaction
      ? { label: t("customer_reaction"), value: status.customerReaction }
      : null,
  ].filter(Boolean) as { label: string; value: string }[];

  if (tooltipItems.length === 0) return tag;

  return (
    <Tooltip
      title={
        <Space direction="vertical" size={2}>
          {tooltipItems.map((item) => (
            <span key={item.label}>
              <Typography.Text strong>{item.label}: </Typography.Text>
              {item.value}
            </span>
          ))}
        </Space>
      }
    >
      {tag}
    </Tooltip>
  );
};

export default CustomerSatisfactionStatusTag;
